import React from "react";
import { ArrowRight, FileText } from "lucide-react";

interface ActionButtonsProps {
  onSpeakToExpert: () => void;
  onStartNewRequest: () => void;
  variant?: "primary" | "secondary";
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onSpeakToExpert,
  onStartNewRequest,
  variant = "primary",
}) => {
  if (variant === "primary") {
    return (
      <div className="mt-8 flex justify-center space-x-4">
        <button
          onClick={onSpeakToExpert}
          className="btn-primary inline-flex items-center justify-center space-x-2"
        >
          <span>Speak to a Mortgage Expert</span>
          <ArrowRight size={18} />
        </button>
        <button
          onClick={onStartNewRequest}
          className="btn-secondary inline-flex items-center space-x-2"
        >
          <FileText size={18} />
          <span>Start New Analysis</span>
        </button>
      </div>
    );
  }

  return (
    <div className="pt-4 flex flex-col sm:flex-row justify-center gap-4">
      <div className="text-center">
        <p className="text-sm text-gray-600 mb-2">
          Have questions or want to refinance?
        </p>
        <div className="flex flex-col gap-2">
          <button
            onClick={onSpeakToExpert}
            className="btn-secondary inline-flex items-center justify-center space-x-2"
          >
            <span>Speak With a Mortgage Expert</span>
            <ArrowRight size={18} />
          </button>
          <button
            onClick={onStartNewRequest}
            className="btn-tertiary mt-2 inline-flex items-center justify-center space-x-2"
          >
            <span>Submit Another Scenario</span>
            <FileText size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActionButtons;
